import {Component, Injector} from '@angular/core';
import {AlertController, NavController, NavParams} from 'ionic-angular';
import {RegisterPage} from "../register/register";
import {HttpClient} from "@angular/common/http";
import {ModalNavPage} from "../modal-nav/modal-nav";
import {GlobalProvider} from "../../providers/global/global";
import {ForgotPasswordPage} from "../forgot-password/forgot-password";
import {LoginProvider} from "../../providers/login/login.provider";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {DatabaseModel} from "../../models/database.model";
import {UserinformationModel} from "../../models/userinformation.model";
import {LoginResponseModel} from "../../models/loginResponse.model";
import {UserModel} from "../../models/user.model";

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  public disableLoginButton: boolean = false;
  public message: string = null;


  private dataProvider: DataProvider = null;
  private loginProvider: LoginProvider = null;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private http: HttpClient,
              private modalNav: ModalNavPage,
              private alertCtrl: AlertController,
              private globalProvider: GlobalProvider,
              private injector: Injector) {

    this.dataProvider = this.injector.get(DataProvider);
    this.loginProvider = this.injector.get(LoginProvider);

    this.message = this.navParams.get('message');
    // this.loginProvider.isLoggedIn();

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }

  public onSubmit(loginForm): void {
    //check login

    // this.disableLoginButton = true;

    this.globalProvider.hasInternet()
      .then(()=>{

        this.loginProvider.login(loginForm.value.email, loginForm.value.password)
          .then((response: LoginResponseModel) => {
            console.dir('logged IN');
            return this.loginProvider.getUserInformations(response.name)
          })
          .then((userInformations: UserinformationModel) => {
            return new Promise((resolve, reject) => {
              this._selectDatabase(userInformations.databases)
                .then((selectedDatabase) => {
                  resolve({user: userInformations.user, selectedDatabase: selectedDatabase})
                }, () => {
                  reject();
                })
            });
          })
          .then((success: {user: UserModel, selectedDatabase: DatabaseModel}) => {
            this.loginProvider.setLoggedIn(success);
            this.modalNav.dismissModal();
            this.dataProvider.initLocalDB();
            this.dataProvider.init();
          })
          .catch((error) => {
            console.dir(error);
            this._onLoginFailed(error);
        })


      }, () => {
        console.log('keine internetverbindung -> login nicht möglich');
      })


  }

  public register(): void {
    this.navCtrl.push(RegisterPage);
  }

  public forgotPassword(): void {
    this.navCtrl.push(ForgotPasswordPage);
  }

  private _onLoginFailed(options: {title: string, message: string}): void {
    //fehler beim einloggen!!
    let alert = this.alertCtrl.create({
      title: options.title,
      subTitle: options.message,
      buttons: ['Ok']
    });
    alert.present();
  }

  private _saveCredentials(username: string, password: string): void {
    // this.loginProvider.setLoggedIn(username, password);
  }

  private _selectDatabase(databases: Array<DatabaseModel>): Promise<DatabaseModel> {

    //show databaselist for selection
    let databaseListAlert = this.alertCtrl.create();
    databaseListAlert.setTitle('Bitte Datenbank auswählen');


    for(let i = 0, length = databases.length; i < length; i++){
      let database = databases[i];
      databaseListAlert.addInput({
        type: 'radio',
        label: database.name,
        value: database.name,
        checked: i === 0 ? true : false
      });
    }

    return new Promise((resolve, reject) => {
      databaseListAlert.addButton({
        text: 'Abbrechen',
        handler: () => {
          reject({title: 'Keine Datenbank ausgewählt', message: 'Bitte wählen Sie eine Datenbank'});
        }
      });
      databaseListAlert.addButton({
        text: 'OK',
        handler: (selectedDatabase: any) => {
          if(selectedDatabase){
            console.log('selected Database:', selectedDatabase);
            resolve(databases.find((_database) => {
              return _database.name = selectedDatabase;
            }));
          }
        }
      });

      databaseListAlert.present();
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts